(function () {
  "use strict";

  CreateSeriesNoActiveCoursesCtrl.$inject = ['$scope'];
  angular
    .module('trainerWebApp.modals')
    .controller('CreateSeriesNoActiveCoursesCtrl', CreateSeriesNoActiveCoursesCtrl);

  function CreateSeriesNoActiveCoursesCtrl($scope) {
    $scope.$on('createSeriesNoActiveCoursesMessageRequested', $scope.show);
  }

})();
